export default {
  groupBy: "Grouper par",
  projects: "Projets",
  clients: "Clients",
  members: "Membres",
  services: "Services",
  durationOverTime: "Durée dans le temps",
  durationByDay: "Durée par jour",
  durationByWeek: "Durée par semaine",
  durationByMonth: "Durée par mois",
  projectDistribution: "Répartition des projets",
  clientDistribution: "Répartition des clients",
  memberDistribution: "Répartition des membres",
  serviceDistribution: "Répartition des services",
  noData: "Aucune donnée pour la période sélectionnée",
  entityName: "Nom",
  duration: "Durée",
  percentage: "Durée %",
  total: "Total",
  period: "Période",
  chartDonutTakeaway:
    "Part la plus élevée : {{name}}, {{percentage}} pour cent de {{total}}",
  chartBarTakeaway:
    "{{total}} au total; la période la plus élevée est {{label}}, à {{duration}}",
  chartBarTakeawayEmpty:
    "{{total}} au total; aucun temps enregistré pour les périodes",
  chartTableCaption: "Données : {{title}}",
};
